module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-wood-rovere-trattato-everest.298b5ed6.jpg";